import ToastError from "./ToastError";

const Toast = {
  Error: ToastError,
};

export default Toast;
